/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';
import React from 'react';

import { Form } from '@mairistem/composants';

import type { Individu } from '@/types';
import { SituationFamiliale } from '@/components/Assistant/StepIdentification';
import { validationSituationFamiliale } from '@/utils';

import PanelModalEdition from '../PanelModalEdition';

interface SituationFamilialeModalProps {
  situationFamiliale: string;
  nombreEnfants: number;
  nombreFreresSoeurs: number;
  pupille: string;
  updated: boolean;
  onSave: () => Promise<void>;
  onChange: (data: Partial<Individu>) => void;
  onClose: () => void;
  onCancel: () => void;
}

const SituationFamilialeModal = (props: SituationFamilialeModalProps) => {
  const {
    situationFamiliale,
    nombreEnfants,
    nombreFreresSoeurs,
    pupille,
    updated,
    onChange,
    onSave,
    onClose,
    onCancel,
  } = props;

  const [loading, setLoading] = React.useState<boolean>(false);
  const [errors, setErrors] = React.useState<
    Partial<Individu> & { api?: boolean }
  >({});

  const handleChange = React.useCallback(
    (
      _e: React.ChangeEvent<HTMLInputElement>,
      data: { name: string; value: string },
    ) => {
      onChange({
        [data.name]: data.value,
      });
    },
    [onChange],
  );

  const handleSave = React.useCallback(() => {
    const e = validationSituationFamiliale({
      nombreEnfants,
      nombreFreresSoeurs,
    });

    setErrors(e);

    if (_.isEmpty(e)) {
      setLoading(true);

      onSave()
        .then(() => {
          onClose();
        })
        .catch(() => {
          setErrors({ api: true });
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [nombreEnfants, nombreFreresSoeurs, onClose, onSave]);

  return (
    <PanelModalEdition
      errors={errors}
      loading={loading}
      header="Situation de famille"
      updated={updated}
      onSave={handleSave}
      onClose={onCancel}
      {...(pupille !== 'prefet' && { size: 'small' })}
    >
      <Form>
        <SituationFamiliale
          situationFamiliale={situationFamiliale}
          nombreEnfants={nombreEnfants}
          nombreFreresSoeurs={nombreFreresSoeurs}
          pupille={pupille}
          onChange={handleChange}
          noSection
          fiche
        />
      </Form>
    </PanelModalEdition>
  );
};

export default SituationFamilialeModal;
